// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"73989170","513":"55434051","703":"32862cc7","787":"ad878da3"}[chunkId] + ".chunk.js";
};